import { BottomSheet } from "components/BottomSheet";
import { DropdownFormProvider } from "components/DropdownFormProvider";
import { FormProvider } from "react-hook-form";
import { SheetPrimaryButton, SheetSecondaryButton } from "./SheetActions";
import { UpdateWasteStationLogicRetVal } from "./useUpdateWasteStationLogic";

type Props = {
  logic: UpdateWasteStationLogicRetVal;
};

export const OperatorWasteStationSheet = ({ logic }: Props) => (
  <BottomSheet
    isOpen={logic.isModalOpen}
    onClose={logic.onModalClose}
    title="Mottagarstation"
  >
    <FormProvider {...logic.form}>
      <form className="space-y-6 pb-2" onSubmit={logic.onSubmit}>
        <DropdownFormProvider
          items={logic.wasteStationDropdownItems}
          label="Mottagarstation"
          name="wasteStationUuid"
          hideClearButton
        />

        <div className="flex gap-x-3 border-t border-gray-75 pt-4">
          <SheetSecondaryButton onClick={logic.onModalClose} />
          <SheetPrimaryButton isLoading={logic.isPending}>
            Spara
          </SheetPrimaryButton>
        </div>
      </form>
    </FormProvider>
  </BottomSheet>
);
